import { render, staticRenderFns } from "./ManageTaxonomy.vue?vue&type=template&id=27fced9b&lang=pug"
import script from "./ManageTaxonomy.vue?vue&type=script&lang=js"
export * from "./ManageTaxonomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports